import { inject } from '@angular/core';
import { Router, CanMatchFn } from '@angular/router';

import { AuthService } from '@/app/core/services/auth/auth.service';

export const GuestGuard: CanMatchFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.hasToken()) {
    return router.createUrlTree(['/']);
  }

  return true;
};
